import type { ShiftGovernanceSettings, ShiftAvailabilityAccess } from 'shared-models';
import { shiftIsoDate } from '../../utils/date.utils';

export const GOVERNANCE_WEEKDAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

export function availabilityDateIsLocked(dateDay: string, weekStart: string, settings: ShiftGovernanceSettings | undefined,
  access: ShiftAvailabilityAccess | undefined, role: string | undefined, now: number): boolean {
  if (settings?.historicalLockDate && dateDay <= settings.historicalLockDate) return true;
  if (role === 'manager') return false;
  if (access?.isManuallyLocked) return true;
  if (settings?.deadlineWeekday == null || !settings.deadlineTime) return false;
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(now)).map(part => [part.type, part.value]));
  const current = `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
  return current >= `${shiftIsoDate(weekStart, settings.deadlineWeekday - 7)} ${settings.deadlineTime}`;
}